import * as actions from '../../constants';
export var clearLoginForm = function clearLoginForm() {
  return {
    type: actions.CLEAR_LOGIN_FORM
  };
};